import { useAuth } from '@parsleyhealth/front-end-utils';
import { buttonReset, OutlineButton } from 'components/atoms/Button';
import { CloseMenuIcon } from 'components/icons/CloseIcon';
import { useCurrentPerson } from 'context/currentPerson';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Spacing, Breakpoints, Zindex } from 'constants/theme';

import { Logo } from '../icons/Logo';
import { Menu } from './Menu';

export const Nav: React.FC<{
  type?: string;
}> = ({ type }) => {
  const { isLoggedIn } = useAuth();
  const person = useCurrentPerson();
  const history = useHistory();
  const [displayMenu, setDisplayMenu] = useState(false);
  const location = useLocation();

  // Hide menu on change of page
  useEffect(() => {
    setDisplayMenu(false);
  }, [location]);

  return (
    <>
      {person.id && <Menu show={displayMenu} />}
      <Bar id="app-navigation">
        <Container>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          {(isLoggedIn || type === 'dashboardNav') && !displayMenu ? (
            <IconButton onClick={() => setDisplayMenu(true)}>
              <MenuIcon />
            </IconButton>
          ) : !isLoggedIn ? (
            <OutlineButton
              onClick={() => {
                history.push('/login');
              }}
              variant="primary"
            >
              Sign In
            </OutlineButton>
          ) : (
            <CloseMenuButton onClick={() => setDisplayMenu(false)}>
              <CloseMenuIcon />
            </CloseMenuButton>
          )}
        </Container>
      </Bar>
    </>
  );
};

const IconButton = styled.button`
  ${buttonReset}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 100%;
  margin-right: -1.25rem;
  cursor: pointer;
`;

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  max-width: ${`${Breakpoints.laptopL}px`};
  width: 100%;
  height: 100%;
  padding: 0px ${Spacing.sm};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Bar = styled.div`
  z-index: ${Zindex.TopNav};
  position: sticky;
  top: 0;
  height: 3.75rem;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

const MenuIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect fill="#4F7F71" height={2} rx={1} width={18} x={3} y={6} />
    <rect fill="#4F7F71" height={2} rx={1} width={18} x={3} y={11} />
    <rect fill="#4F7F71" height={2} rx={1} width={18} x={3} y={16} />
  </svg>
);

const CloseMenuButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: ${Spacing.sm};
  height: ${Spacing.l};
  width: 64px;
  z-index: ${Zindex.NavControl};
`;
